import { DateTime } from "luxon";

export const formatTimelineRadarMarker = (
  timestamp: number,
  timezone: string
): string => {
  if (!timestamp) return "";

  // Timestamp comes in milliseconds from useRadarTimelineData
  const currentTime = DateTime.fromMillis(timestamp).setZone(timezone);

  return currentTime.toFormat("H:mm'h'");
};
